import { TinValidation } from "../../../domain/TinValidation/schema"
import { postData, buildUrl } from "../apiService"

const apiRoutes = {
  post: {
    TIN_VALIDATION_ROUTE: "/tin-validation/validateTin",
  },
}

const validateTin = async (
  tin: string,
  fullName: string,
): Promise<TinValidation | void> => {
  return postData(buildUrl(apiRoutes.post.TIN_VALIDATION_ROUTE), {
    tin,
    fullName,
  })
}

export const tinValidationApi = {
  post: {
    TIN_VALIDATION: validateTin,
  },
}
